import { useTranslation } from 'react-i18next';

import type { Board } from '@/entities/board';
import type { MemberRole } from '@/entities/collab';
import { Dialog } from '@/shared/ui';

import { type AccessTab, BoardAccessPanel } from './BoardAccessPanel';

interface Props {
  board: Board;
  role: MemberRole;
  permissions: readonly string[];
  initialTab?: AccessTab;
  onClose: () => void;
}

/** The fast access dialog (the key button beside the avatars): the shared access panel. */
export function AccessDialog({ board, role, permissions, initialTab = 'people', onClose }: Props) {
  const { t } = useTranslation();
  return (
    <Dialog title={t('access.title', { name: board.name })} size="lg" onClose={onClose}>
      <BoardAccessPanel
        board={board}
        role={role}
        permissions={permissions}
        initialTab={initialTab}
      />
    </Dialog>
  );
}
